<template>
  <v-container fluid class="my-5">
    <OfficeDashboard />
  </v-container>
</template>

<script>
import OfficeDashboard from '@/components/office/OfficeDashboard.vue'

export default {
  name: 'oficina_dashboard',
  components: {
    OfficeDashboard
  }
}
</script>
